export class Classification {
  public id?: number;
  public parent_id: number;
  public name: string;
  public classification_type_id: number;
  public classification_type?: ClassificationType;
  public parentName?: string;
}

export class StoreClassification {
  public id?: number;
  public classification_detail_id: number;
}

export class ClassificationDetail {
  public id?: number;
  public classification: Classification;
  public classification_id: number;
  public code: string;
  public description: string;
}

export class ClassificationType {
  public id?: number;
  public name: string;
}



// WEBPACK FOOTER //
// ./src/app/models/classification.model.ts